'use client';
import React from 'react';
import styled from '@benzinga/themetron';
import { Skeleton } from '@benzinga/core-ui';

export interface NewsListItemElementSkeletonProps {
  variant?: 'primary' | 'secondary';
  showAuthor?: boolean;
  showImage?: boolean;
  showTeaser?: boolean;
  showTicker?: boolean;
  showTime?: boolean;
  isSponsored?: boolean;
}

export const NewsListItemElementSkeleton: React.FC<NewsListItemElementSkeletonProps> = ({
  isSponsored = false,
  showAuthor = false,
  showTeaser = false,
  showTicker = true,
  variant = 'primary',
}) => {
  return (
    <NewsListItemElementWrapper className={`news-block ${variant} news-block-skeleton`} imageSize={0}>
      {variant === 'primary' ? (
        <>
          <div className="news-block-headline">
            <div className="flex">
              <div className="w-full">
                {isSponsored ? <span className="news-item-sponsored-tag mb-2">Sponsored</span> : null}
                <Skeleton active paragraph={{ rows: 2 }} />
                {showTeaser && <Skeleton active paragraph={{ rows: 1 }} />}
                <div>
                  {showAuthor && !isSponsored ? <Skeleton active paragraph={{ rows: 1 }} /> : null}
                  {!isSponsored ? <Skeleton active paragraph={{ rows: 1 }} /> : null}
                </div>
              </div>
            </div>
          </div>
          {showTicker && (
            <div className="flex gap-2 ticker-list">
              <div className="w-24 min-h-5">
                <Skeleton active variant={'box'} />
              </div>

              <div className="w-24 min-h-5">
                <Skeleton active variant={'box'} />
              </div>

              <div className="w-24 min-h-5">
                <Skeleton active variant={'box'} />
              </div>
            </div>
          )}
        </>
      ) : (
        <div className="flex">
          <div className="whitespace-nowrap pr-2 date-box">
            <Skeleton active paragraph={{ rows: 1 }} />
          </div>
          <div>
            {showTicker && (
              <div className="flex gap-2 ticker-list">
                <div className="w-24 min-h-5">
                  <Skeleton active variant={'box'} />
                </div>

                <div className="w-24 min-h-5">
                  <Skeleton active variant={'box'} />
                </div>

                <div className="w-24 min-h-5">
                  <Skeleton active variant={'box'} />
                </div>
              </div>
            )}
            <span>
              <Skeleton active paragraph={{ rows: 2 }} />
            </span>
          </div>
        </div>
      )}
    </NewsListItemElementWrapper>
  );
};

const NewsListItemElementWrapper = styled.div<{ imageSize: number }>`
  &.news-block {
    line-height: ${({ theme }) => theme.lineHeight.normal};
    .news-block-headline {
      .news-item-sponsored-tag {
        display: block;
        font-size: 13px;
        color: ${({ theme }) => theme.colorPalette.blue500};
        font-weight: ${({ theme }) => theme.fontWeight.semibold};
      }
    }
    .news-block-image-wrapper {
      width: ${props => props.imageSize}px;
      height: ${props => props.imageSize}px;
      min-width: ${props => props.imageSize}px;
      margin-right: 1rem;
      border-radius: ${({ theme }) => theme.borderRadius.default};
      overflow: hidden;
    }

    .date-box {
      min-width: 130px;
    }
  }

  .skeleton .skeleton-child {
    margin-bottom: 10px;
  }

  .ticker-list {
    .skeleton .skeleton-child {
      margin-bottom: 0px;
    }
  }
`;
